<template>
    <div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    methods: {
        ...mapActions("UserController", [
        "USER_LOGOUT",
        ]),
    },
    async created() {
        try {
            this.USER_LOGOUT()
                .then((result) => {
                    this.$router.replace("/");
                })
                .catch((err) => {
                    });
        
        } catch (e) {
            this.$router.push({ name: 'Unauthorized' });
        }
    }
}
</script>